import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
} from "design-react-kit";
import { ROUTES } from "const";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { MSelect } from "components/forms";
import { getCurrentRegion, setCurrentRegion } from "store/actions";
import { Title } from "components/misc";

class DashboardSteward extends Component {
  state = {
    currentRegion: "",
  };

  PAYLOAD_REGION = {
    options: [
      { label: "SELEZIONARE LA REGIONE", value: "" },
      { label: "ABRUZZO", value: "ABRUZZO" },
      { label: "CALABRIA", value: "CALABRIA" },
      { label: "CAMPANIA", value: "CAMPANIA" },
      { label: "LAZIO", value: "LAZIO" },
      { label: "LOMBARDIA", value: "LOMBARDIA" },
      { label: "MOLISE", value: "MOLISE" },
      { label: "PIEMONTE", value: "PIEMONTE" },
      { label: "PUGLIA", value: "PUGLIA" },
      { label: "SICILIA", value: "SICILIA" },
      { label: "TOSCANA", value: "TOSCANA" },
      { label: "VENETO", value: "VENETO" },
      { label: "EMILIA ROMAGNA", value: "EMILIA ROMAGNA" },
    ],
  };

  cards = [
    {
      title: "LEZIONI",
      link: ROUTES.STEWARD_VERIFY_IDENTITY_LESSONONSITE,
      img: "/img/icon/qrCodeScanner.png",
      className: "image-box",
    },
    {
      title: "TIROCINIO INDIRETTO",
      link: ROUTES.STEWARD_VERIFY_IDENTITY_LESSONTRAINING,
      img: "/img/icon/qrCodeScanner.png",
      className: "image-box",
    },
  ];

  componentDidMount() {
    this.setState({ currentRegion: getCurrentRegion() });
  } //componentDidMount

  onChangeRegion = (id, value) => {
    // Save the selected region in cache
    this.setState({ currentRegion: value });
    setCurrentRegion(value);
  };

  //--- ---
  render() {
    const { currentRegion } = this.state;
    return (
      <>
        <section id="course-sections">
          <div className="my-4">
            {currentRegion !== "" && currentRegion !== null ? (
              <Container>
                <Title>REGIONE {currentRegion}</Title>
                <Row>
                  {this.cards.map((card, i) => (
                    <Col
                      size="12"
                      xs={12}
                      sm={4}
                      md={3}
                      xl={2}
                      key={`card-${i}`}
                    >
                      <article className="mb-4 card-space">
                        <Card
                          className="no-after card-bg rounded shadow border-bottom-card text-center"
                          noWrapper={false}
                          tag="div"
                        >
                          <Link className="wrapper-link" to={`${card.link}`}>
                            <img
                              className={card.className}
                              alt={card.title}
                              src={card.img}
                            ></img>
                            <CardBody tag="div" className="minH-card-body">
                              <CardFooter tag="h6">{card.title}</CardFooter>
                            </CardBody>
                          </Link>
                        </Card>
                      </article>
                    </Col>
                  ))}

                  <Col size="12" xs={12} sm={4} md={3} xl={2}>
                    <article className="mb-4 card-space">
                      <Card
                        className="no-after card-bg rounded shadow border-bottom-card text-center"
                        noWrapper={false}
                        tag="div"
                      >
                        <Link
                          className="wrapper-link"
                          to={ROUTES.STEWARD_LESSON_TODAY}
                        >
                          <img
                            className={"image-box"}
                            alt={"Lezione di oggi"}
                            src={"/img/icon/italy.png"}
                          ></img>
                          <CardBody tag="div" className="minH-card-body">
                            <CardFooter tag="h6">
                              LEZIONI/ATTIVITA' DI OGGI
                            </CardFooter>
                          </CardBody>
                        </Link>
                      </Card>
                    </article>
                  </Col>
                </Row>
              </Container>
            ) : (
              <Container>
                <Row>
                  <Col size="12" xs={12} sm={12} md={12} xl={12}>
                    <article
                      className="mb-4 mx-auto card-space"
                      style={{ maxWidth: "600px" }}
                    >
                      <Card
                        className="no-after card-bg rounded shadow border-bottom-card text-center"
                        noWrapper={false}
                        tag="div"
                      >
                        <Link className="wrapper-link" to="#">
                          <img
                            className={"image-box"}
                            alt={"Seleziona la regione in cui ti trovi"}
                            src={"/img/icon/italy.png"}
                          ></img>
                          <CardBody tag="div" className="minH-card-body">
                            <h6>Seleziona la regione in cui ti trovi:</h6>
                            <div className="m-5" style={{ fontSize: "15px" }}>
                              <MSelect
                                id="region-select"
                                name="region-select"
                                onChange={this.onChangeRegion}
                                payload={this.PAYLOAD_REGION}
                              />
                            </div>
                          </CardBody>
                        </Link>
                      </Card>
                    </article>
                  </Col>
                </Row>
              </Container>
            )}
          </div>
        </section>
      </>
    );
  }
}

export default withRouter(DashboardSteward);
